import { render, staticRenderFns } from "./ActiveImportNotice.vue?vue&type=template&id=58acc460&scoped=true&"
import script from "./ActiveImportNotice.vue?vue&type=script&lang=js&"
export * from "./ActiveImportNotice.vue?vue&type=script&lang=js&"
import style0 from "./ActiveImportNotice.vue?vue&type=style&index=0&id=58acc460&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58acc460",
  null
  
)

export default component.exports